var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsEnum, IsNumber, IsString, IsUUID } from 'class-validator';
import { OfficeAchievementLevelStatus } from '../enums/office-achievement-level-status.enum.js';
import { OfficeAchievementLevelChallengeResponseDto } from './office-achievement-level-challenge.response.dto.js';
export class OfficeAchievementLevelResponseDto {
    id;
    createdAt;
    updatedAt;
    levelName;
    levelNumber;
    levelEmoji;
    officeAchievementLevelChallenges;
    status;
}
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementLevelResponseDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], OfficeAchievementLevelResponseDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], OfficeAchievementLevelResponseDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementLevelResponseDto.prototype, "levelName", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], OfficeAchievementLevelResponseDto.prototype, "levelNumber", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementLevelResponseDto.prototype, "levelEmoji", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => OfficeAchievementLevelChallengeResponseDto),
    __metadata("design:type", Array)
], OfficeAchievementLevelResponseDto.prototype, "officeAchievementLevelChallenges", void 0);
__decorate([
    Expose(),
    IsEnum(() => OfficeAchievementLevelStatus),
    __metadata("design:type", String)
], OfficeAchievementLevelResponseDto.prototype, "status", void 0);
//# sourceMappingURL=office-achievement-level.response.dto.js.map